import React from 'react';
import './Footer.css'
import { FaGithub, FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";


const Footer = () => {
    return (
        <div className='footer' >
          <div className='footer-content'>
          <h3 data-aos="flip-right">Sabbir Ahmed Nayeem</h3>
            <p>My full name is sabbir ahmed nayeem . I am a web Developer in React. </p>
            <div data-aos="fade-up"
     data-aos-duration="3000">
                               <button className='icon-button'>
                                    <a className='icon-button' href="https://github.com/nayeem98746"><FaGithub></FaGithub></a>
                                    
                                </button>
                               <button className='icon-button'>
                                    <a href="https://www.facebook.com/sabbirahmed.nayeem.10" className='icon-button'>  <FaFacebook></FaFacebook> </a>
                               </button>
                               <button className='icon-button'> <a href="https://www.instagram.com/sabbirahmednayeem/" className='icon-button'> <FaInstagram></FaInstagram> </a></button>
                                <button className='icon-button'><a href="https://www.linkedin.com/in/sabbir-ahmed-b98b0a226/" className='icon-button'> <FaLinkedin></FaLinkedin> </a></button>
                                
                            </div>  
            </div> 
            <div className='footer-button'>
            <p>Copyright and copy © 2020 codeOpacity.</p>    
            </div>         
        </div>
    );
};

export default Footer;